export default "__VITE_ASSET__vMMQyN5g__"